<ng-container *ngIf="currentUser">
    <div class="sidebar-user-info">
        <div class="sidebar-user-info__user">
            <div *ngIf="!isCurrentUserPicture" class="user-initial">{{ userAbbreviation }}</div>
            <div *ngIf="isCurrentUserPicture" class="user-photo">
                <img alt="User avatar" [src]="currentUserPicture" />
            </div>
            <div class="d-flex user-info">
                <div class="user-name">{{ user.name }}</div>
                <span>Role: {{ user.role }}</span>
                <span>Org: {{ user.businessUnitName }}</span>
            </div>
        </div>
        <div *ngIf="!isSwitchRole">
            <mat-icon>chevron_right</mat-icon>
        </div>
    </div>
</ng-container>
